import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/question-black-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-5417d2c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter-col-aistart" }
const _hoisted_2 = { class: "fx-1 flex-col" }
const _hoisted_3 = { class: "flex-ter" }
const _hoisted_4 = {
  class: "item-label",
  style: {"word-break":"break-word"}
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "flex-ter"
}
const _hoisted_7 = {
  class: "item-label",
  style: {"word-break":"break-word"}
}
const _hoisted_8 = {
  key: 1,
  class: "flex-ter fx-1 mt_30 rel"
}
const _hoisted_9 = { class: "item-label" }
const _hoisted_10 = { class: "express-content" }
const _hoisted_11 = {
  key: 2,
  class: "flex-ter fx-1 mt_30 rel",
  style: {"width":"710px"}
}
const _hoisted_12 = { class: "item-label" }
const _hoisted_13 = { class: "item-content-item flex-ter" }
const _hoisted_14 = { class: "item-content-item flex-ter" }
const _hoisted_15 = { class: "item-content-item flex-ter" }
const _hoisted_16 = { class: "item-content-item flex-ter" }
const _hoisted_17 = { class: "item-content-item flex-ter" }
const _hoisted_18 = { class: "item-content-item flex-ter" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 3,
  class: "flex-ter fx-1 mt_30 rel",
  style: {"width":"710px"}
}
const _hoisted_21 = { class: "item-label" }
const _hoisted_22 = { class: "item-content" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 0,
  style: {"margin-top":"40px","font-weight":"600","font-size":"16px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"280px"} }, [
  /*#__PURE__*/_createTextVNode(" 「マイページ」ー「店舗管理」ー「注文関連設定」から、事前に販売プラットフォーム名称申告情報をご登録いただくと、通関手続きがよりスムーズになります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 👉 ご案内："),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://s.theckb.com/sub/notice/27",
    target: "_blank",
    style: {"color":"#1890ff"}
  }, "https://s.theckb.com/sub/notice/27")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {"width":"14px","cursor":"pointer"}
}, null, -1))
const _hoisted_28 = { class: "declare-content" }

import { t } from '@/plugins/i18n'
import { ref, computed, reactive, watch, onMounted } from 'vue'
import { isD2C, expressCostPdf, useSite2Code, isJA, isKO, useSite, isEN, isMultiStore } from '@/store'
import ReceiveSheet from './ReceiveSheet.vue'
import DeliAdt from '@/components/additional/DeliAdt.vue'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { useRequest } from '@/util/useLoading'
import {
  RecommendedLogistics,
  getShopLogistics,
  updateShopLogistics
} from '@/apis/setup'
import { getAddressCodeName } from '@/util/useCountry'
import { ElMessage, FormInstance } from 'element-plus'
import setName from '@/util/useArea'
import { getCustomerShop } from '@/apis/order'
import { adt } from '@/util/useData'
import { throughCountryGetExpressApi } from '@/apis/user'
import { cloneDeep } from 'lodash'
import HelpTooltip from '@/components/common/helpTooltip.vue'
import ShopExpressConfig from './ShopExpressConfig.vue'
import { useStore } from 'vuex'
import { jpWareInfo } from '@/common/const'
import { log } from 'console'
import { request } from '@/config/request/interceptors'

export default /*#__PURE__*/_defineComponent({
  props: ['logisticsSourceCountry'],
  setup(__props) {

const props = __props
const questionIcon = require('@/assets/image/icon/question-black-icon.png')
// 申请 code
const declarePlatform = reactive({
  declarePlatformName: '',
  declarePlatformCode: ''
})
const declarePlatformRef = ref<FormInstance>()
const submitForm = async () => {
  declarePlatformRef.value?.validate(async (valid) => {
    if (valid) {
      const res = await request.customer.customer.shopUpdateShopDeclarePlatform({
        customerShopId: store.getters.curShop,
        declarePlatformName: declarePlatform.declarePlatformName,
        declarePlatformCode: declarePlatform.declarePlatformCode
      })
      if (res.success) {
        ElMessage.success(t('保存成功'))
      }
    }
  })
}

onMounted(async () => {
  if (isJA()) {
    const res = await request.customer.customer.shopGetCustomerShopById()
    declarePlatform.declarePlatformName = res.data?.declarePlatformName || ''
    declarePlatform.declarePlatformCode = res.data?.declarePlatformCode || ''
  }
})

// 获取组件默认国家商品


// 若是国家变了要重新初始化
watch([() => props.logisticsSourceCountry], () => {
  init()
})

const store = useStore()
/** 当前店铺 */
const curShop = store.state.route.curShop
/** 当前店铺信息的仓库配置 */
const warehouseCodeList = computed(() => {
  return [...(store.getters.user.customerShopList.find((item: any) => item.customerShopId === curShop)?.warehouseList ?? []), jpWareInfo]
})
// 获取仓库名称
const wareName = computed(() => {
  return warehouseCodeList.value?.find((item) => item.warehouseCountry === props.logisticsSourceCountry)?.warehouseNameTranslate
})
// 韩国的，获取仓库名称
const krWareName = computed(() => {
  return warehouseCodeList.value?.find((item) => item.warehouseCountry === 'KR')?.warehouseNameTranslate
})
const warehouseCode = computed(() => {
  return warehouseCodeList.value?.find((item) => item.warehouseCountry === props.logisticsSourceCountry)?.warehouseCode
})
const getName = (code: string) => {
  if (code === 'JP' && isJA()) {
    return 'nameJa'
  }
  if (code === 'KR' && isKO()) {
    return 'nameKr'
  }
  return 'nameEn'
}
const delReceive = () => {
  data.value.addressAddition = {
    ...data.value.addressAddition,
    sendName: '',
    countryCode: '',
    sendTel: '',
    area: '',
    areaName: '',
    city: '',
    cityName: '',
    address: '',
    postalCode: ''
  }
}

const update = () => {
  return getShopLogistics({ warehouseCode: warehouseCode.value }).then(async (res) => {
    const data = res.data
    let addressInfo: any = {}
    if (data) {
      data.addressAddition = data.addressAdditionRespDTO ?? {}
      const adtRes = await adt().then((data) => {
        return data.deliveryAdditionList.map((v: any) => {
          const t = { ...v }
          return t
        })
      })
      const list: any = [];
      (data.additionItemList ?? []).forEach((item: any) => {
        const n = adtRes.find((i: any) => i.additionCode === item.additionCode)
        list.push({
          ...n,
          ...item
        })
      })
      // data.additionList = adtRes.filter((v:any) => (data.additionItemList ?? []).find((v2:any) => v2.additionId === v.additionId))
      data.additionList = list
      delete data.addressAdditionRespDTO
      delete data.additionItemList
      addressInfo = await getAddressCodeName({
        countryCode: !data.addressAddition.countryCode ? '' : (data.addressAddition.countryCode.indexOf('+') > -1 ? useSite2Code() : data.addressAddition.countryCode),
        area: data.addressAddition.area,
        city: data.addressAddition.city
      })
      console.log('xxxx', addressInfo)
      getExpress(addressInfo.countryCode)
    }
    return { ...data, ...addressInfo }
  })
}

const [loading, api] = useRequest(updateShopLogistics)
// 获取国家下的物流
const getExpress = (code: any) => {
  throughCountryGetExpressApi({
    warehouseCode: warehouseCode.value,
    countryCode: code,
    systemSource: isD2C() ? 1 : 2
  }).then((res: any) => {
    if (res.success) {
      expresses.value = res.data
    }
  })
}

const data: any = ref({
  addressAddition: {},
  additionList: []
})
const init = async () => {
  data.value = (await update()) ?? {
    additionList: [],
    addressAddition: {
      sendName: '',
      countryCode: '',
      sendTel: '',
      area: '',
      areaName: '',
      city: '',
      cityName: '',
      address: '',
      email: '',
      postalCode: '',
      logisticsId: '',
      logisticsName: ''
    }
  }
}
init()

const commit = () => {
  throughCountryGetExpressApi({
    warehouseCode: warehouseCode.value,
    // countryCode: info.value.countryCode,
    countryCode: !info.value.countryCode || info.value.countryCode.indexOf('+') > -1 ? useSite2Code() : info.value.countryCode,
    systemSource: isD2C() ? 1 : 2
  }).then((res: any) => {
    if (!res.data || !res.data.find((i: any) => i.intShipConfigId === data.value.addressAddition.logisticsId)) {
      data.value.addressAddition.logisticsId = ''
    }
    const params = cloneDeep(data.value)
    delete params.areaItem
    delete params.areaList
    delete params.cityItem
    delete params.cityList
    delete params.countryItem
    delete params.countryList
    api({ ...params, warehouseCode: warehouseCode.value }).then(async (res) => {
      if (res?.success) {
        ElMessage.success(t('物流配置修改成功'))
        // const add = await getAddressCodeName(data.value.addressAddition)
        data.value = await update()
        // 配置完成 获取国家下的物流
        getExpress(data.value.countryCode)
      }
    })
  })
}

// 物流公司
const expresses: any = ref([])
// RecommendedLogistics().then((res) => {
//   if (res.success) {
//     expresses.value = res.data
//   }
// })

// 发货地址
const info = computed({
  get: () => data.value.addressAddition,
  set: (val) => {
    Object.entries(val).forEach(([k, v]) => {
      data.value.addressAddition[k] = v
    })
  }
})
const showReceive = ref(false)

// 国际物流附加项
const cfg = computed({
  get: () => data.value.additionList,
  set: (val) => {
    data.value.additionList = val
    commit()
  }
})
const showAdt = ref(false)
const editIcon = require('@/assets/image/icon/floatrate/edit.png')

// watch(data.value, () => commit(), { deep: true })

const edit = () => {
  showReceive.value = true
}
// const logisticsId = computed({
//   get: () => {
//     console.log('expresses.value',expresses.value)
//     const isHave = expresses.value.find((i:any) => i.intShipConfigId === data.value.addressAddition.logisticsId)
//     return isHave ? data.value.addressAddition.logisticsId : ''
//   },
//   set: (v) => {
//     console.log(v)
//     data.value.addressAddition.logisticsId = v
//     commit()
//   }
// })

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElForm = _resolveComponent("ElForm")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["shop-express flex-center-col", _unref(useSite)()])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('店铺仓库所在地')), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(wareName) ?? '-'), 1),
          (_unref(isMultiStore)() && !_unref(isD2C)())
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                style: {"margin-left":"20px"},
                target: "_blank",
                class: _normalizeClass(_unref(useSite)()),
                href: _unref(expressCostPdf)()
              }, _toDisplayString(_unref(t)('国际料金表')) + ">", 11, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        (!_unref(isD2C)() && _unref(isMultiStore)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('店铺仓库所在地')), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(krWareName) ?? '-'), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(isD2C)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('选择物流公司')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(ShopExpressConfig, { warehouseCode: _unref(warehouseCode) }, null, 8, ["warehouseCode"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(isD2C)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('国际面单主设定')), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["item-content", _unref(useSite)()])
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('姓名')) + ":", 1),
                  _createTextVNode(_toDisplayString(_unref(info).sendName), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('联系电话')) + ":", 1),
                  _createTextVNode(_toDisplayString(data.value.countryItem?.areaNum ? '+' + data.value.countryItem?.areaNum : '') + " " + _toDisplayString(_unref(info).sendTel), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('都道府县')) + ":", 1),
                  _createTextVNode(" " + _toDisplayString(data.value?.countryItem?.[getName(data.value.countryCode)]) + " " + _toDisplayString(data.value?.areaItem?.[getName(data.value.countryCode)]), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('市')) + ":", 1),
                  _createTextVNode(" " + _toDisplayString(data.value?.cityItem?.[getName(data.value.countryCode)]), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('详细地址')) + ":", 1),
                  _createTextVNode(_toDisplayString(_unref(info).address), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('邮编')) + ":", 1),
                  _createTextVNode(_toDisplayString(_unref(info).postalCode), 1)
                ])
              ], 2),
              _createElementVNode("div", {
                class: "abs openPanel flex-ter cursor-pt",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showReceive.value = true))
              }, [
                _createElementVNode("img", {
                  src: _unref(editIcon),
                  alt: ""
                }, null, 8, _hoisted_19),
                _createTextVNode(_toDisplayString(_unref(t)('修改')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(isD2C)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('发货附加项')), 1),
              _createElementVNode("div", _hoisted_22, [
                (_unref(cfg))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(cfg).map((v) => v.additionNameJp).join('，')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "abs openPanel flex-ter cursor-pt",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showAdt.value = true))
              }, [
                _createElementVNode("img", {
                  src: _unref(editIcon),
                  alt: ""
                }, null, 8, _hoisted_24),
                _createTextVNode(_toDisplayString(_unref(t)('打开全部')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(isJA)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createTextVNode(_toDisplayString(_unref(t)('海关申报信息')) + " ", 1),
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "top",
              "popper-class": "tool-tip-no-border"
            }, {
              content: _withCtx(() => [
                _hoisted_26
              ]),
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        (_unref(isJA)() && __props.logisticsSourceCountry === 'CN')
          ? (_openBlock(), _createBlock(_component_ElForm, {
              key: 0,
              labelWidth: "200px",
              style: {"margin-top":"20px"},
              ref: (_value, _refs) => {
                _refs['declarePlatformRef'] = _value
                declarePlatformRef.value = _value
              },
              model: _unref(declarePlatform)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElFormItem, {
                  label: "プラットフォーム名称",
                  prop: "declarePlatformName",
                  rules: [{ required: true, message: _unref(t)('必填'), trigger: 'blur' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElInput, {
                      modelValue: _unref(declarePlatform).declarePlatformName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(declarePlatform).declarePlatformName) = $event)),
                      maxLength: "70",
                      label: _unref(t)('请输入')
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_ElFormItem, {
                  label: "プラットフォーム等コード",
                  prop: "declarePlatformCode",
                  rules: [{ required: true, message: _unref(t)('必填'), trigger: 'blur' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElInput, {
                      modelValue: _unref(declarePlatform).declarePlatformCode,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(declarePlatform).declarePlatformCode) = $event)),
                      maxLength: "20",
                      label: _unref(t)('请输入')
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_ElFormItem, { label: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElButton, {
                      type: "primary",
                      onClick: submitForm
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(ReceiveSheet, {
      modelValue: showReceive.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showReceive).value = $event)),
      data: _unref(info),
      "onUpdate:data": _cache[5] || (_cache[5] = ($event: any) => (_isRef(info) ? (info).value = $event : null)),
      onChange: commit
    }, null, 8, ["modelValue", "data"]),
    (showAdt.value)
      ? (_openBlock(), _createBlock(AdditionDrawer, {
          key: 0,
          countryCode: props.logisticsSourceCountry,
          warehouseCode: _unref(warehouseCode),
          cfg: _unref(cfg),
          "onUpdate:cfg": _cache[6] || (_cache[6] = ($event: any) => (_isRef(cfg) ? (cfg).value = $event : null)),
          onClose: _cache[7] || (_cache[7] = ($event: any) => (showAdt.value = false)),
          type: "DeliAdt",
          title: _unref(t)('发货附加项')
        }, null, 8, ["countryCode", "warehouseCode", "cfg", "title"]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_loading, _unref(loading)]
  ])
}
}

})